// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema). The
// fuller domain `CustomerSchema` in `../schemas/index.ts` validates
// server-returned records (id, full enum status, etc); this schema validates
// the in-flight form values, matching the prior Yup-enforced required-field
// set.
import {z} from 'zod';

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    status: z.string().min(1, 'Required'),
    contactInfo: z.object({
        email: z.string().email('Invalid email').min(1, 'Required'),
    }).optional(),
});
